import { render } from "./RequestAccess.vue?vue&type=template&id=dad21636&scoped=true&ts=true"
import script from "./RequestAccess.vue?vue&type=script&lang=ts"
export * from "./RequestAccess.vue?vue&type=script&lang=ts"

import "./RequestAccess.vue?vue&type=style&index=0&id=dad21636&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dad21636"]])

export default __exports__